import CarnetFormController from './carnet.form.controller';

export default {
    template: require('./carnet.form.html'),
    controller: CarnetFormController
};
